import { SxSView } from '../Schema/SxSView';
import { EditMode } from '../Schema/WacFileEditState';
import getInitialSxSViewState from 'owa-sxsdata/lib/utils/getInitialSxSViewState';
import { createStore } from 'satcheljs';

const initialStore: SxSView = {
    datapoint: null,
    wacFileEditState: {
        fileUrl: '',
        editAllowed: false,
        mode: EditMode.View,
    },
    viewState: getInitialSxSViewState(),
};

export const getSxSViewStore = createStore<SxSView>('SxSStore', initialStore);
